<template>
  <div>
    <serviceAccountCard :serviceAccounts="serviceAccounts"></serviceAccountCard>
  </div>
</template>

<script>
import ServiceAccountCard from "@/components/ServiceAccountCard.vue";
import Api from "@/services/Api";

export default {
  components:{
    serviceAccountCard: ServiceAccountCard
  },
  data() {
    return {
    serviceAccounts: []
    }
  },
  computed: {
    
  },

  watch: {

  },
  created() {
    this.initialize();
  },  
  methods: {
    fetchServiceAccounts() {
      Api()
        .get("/serviceAccounts")
        .then(response => {
          this.serviceAccounts = response.data;
        });
    },     
    initialize() {
      this.fetchServiceAccounts();
    }
  }
}
</script>